import isEqual from 'lodash/isEqual';

const defaultSelectorProps = {
    memoizeOptions: {
        equalityCheck: (a, b) => isEqual(a, b)
    }
};

export default defaultSelectorProps;
